
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";

@Component({ components: {} })
export default class DelExam extends Vue {
  @Prop() private isShowDelModal!: boolean;
  @Prop() private delParam!: any;

  form = { val: "" };
  rules = {
    val: [
      { required: true, message: "请输入“确认删除”", trigger: "blur" },
      {
        validator: (rule: unknown, value: string, callback: Function) => {
          if (value !== "确认删除") {
            return callback(new Error("请输入“确认删除”"));
          } else {
            return callback();
          }
        },
        trigger: ["blur"]
      }
    ]
  };
  showAlert = false;

  @Emit("on-del-cancel")
  delCancel() {
    this.form.val = "";
    this.showAlert = false;
    return;
  }

  @Emit("on-del-success")
  delSuccess() {
    return new Promise(resolve => {
      (this.$refs.formRef as ElForm).validate(valid => {
        if (!valid) return;

        this.showAlert = false;
        this.form.val = "";
        resolve();
      });
    });
  }
}
